import { useEffect, useState } from "react"
import { api, FRONT } from "../../../env"

export default function UniversalLinkCard({ programId }) {
    const [links, setLinks] = useState(null)
    const [isGenerating, setIsGenerating] = useState(false)

    const fetchLinks = () => {
        api.get(`programs/${programId}/public-invitations`)
            .then(res => setLinks(res.data.data ?? []))
            .catch(() => setLinks([]))
    }

    useEffect(() => {
        fetchLinks()
    }, [programId])

    const handleGenerate = () => {
        setIsGenerating(true)
        api.post(`programs/${programId}/public-invitations/generate`)
            .then(() => fetchLinks())
            .catch(() => {})
            .finally(() => setIsGenerating(false))
    }

    if (links === null) return <div className="card" />

    const mentorLink = links.find(l => l.type === 'Mentor')
    const menteeLink = links.find(l => l.type === 'Mentee')

    return (
        <div className="card flex columns space-between gap-s">
            <div>
                <p className="section-title-s v-spacer-xs">Universal link</p>
                <p className="label-m o-50">Share a public link in Slack, LinkedIn, anywhere. People who use it auto-join.</p>
            </div>
            
            {links.length === 0 ? (
                <button className="solid large" onClick={handleGenerate} disabled={isGenerating}>
                    {isGenerating ? "Generating..." : "Generate public invite links"}
                </button>
            ) : (
                <div className="flex columns gap-xs">
                    <LinkRow label="Mentor signup link" url={mentorLink ? `${FRONT}participant/invites/${mentorLink.code}` : null} />
                    <LinkRow label="Mentee signup link" url={menteeLink ? `${FRONT}participant/invites/${menteeLink.code}` : null} />
                    <p className="label-s o-50">&#9888; Anyone with the link joins automatically — no review step.</p>
                </div>
            )}
        </div>
    )
}

function LinkRow({ label, url }) {
    if (!url) return null
    return (
        <div className="flex columns gap-xxs">
            <p className="label-s o-50">{label}</p>
            <div className="dashed-card space-between standard-padding-xs silent-scroll">
                <input value={url}></input>
                <button className="elevated" onClick={() => navigator.clipboard.writeText(url)}>Copy</button>
            </div>
        </div>
    )
}
